import React from "react";
// gatsbyjs core
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
// matrial-ui actions
import { makeStyles } from '@material-ui/core/styles';
// matrial-ui core components
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
/**/ 
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
// custom icons
import PlusCircleIcon from '@icons/PlusCircleIcon';
import TaskIcon from '@icons/TaskIcon';
import LocationIcon from '@icons/LocationIcon';
import PhoneIcon from '@icons/PhoneIcon';
// for reponsive
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';




/**
 * @custom_style
 */
const useStyles = makeStyles((theme) => ({
  warrp : {
    width: '100%',
    position: 'relative',
    '&::before': {
        position: 'absolute',
        content: "''",
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1
      }
  },
  container: {
    position: 'absolute',
    top: 10,
    right: 0,
    zIndex: 2,
    width: '100%',
  },
  content: {
    width: '66%',
    margin: '0 auto',
    padding: '2% 0',
    //
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
  },
  title: {
    fontWeight: 'Bold',
    fontSize: 40,
    textAlign: 'center',
    color: '#FFFFFF',
    padding: 25
  },
  listItem: {
    textAlign: 'right'
  },
  listText: {
    color: 'white',
    padding: 13
  },
  listAvatar:{
    backgroundColor: '#bdbdbd4d',
    width: 60,
    height: 60
  }
}));


/**
 * 
 */
function SectionFromHeader (props) {
  const classes = useStyles();

  // image query
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "form-hero.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);
    
  return (
    <Hidden smDown>
      <Box className={classes.warrp}>
          
            {/* Header Image */}
            <Img
              fluid={data.file.childImageSharp.fluid}
              alt="دورلى"
            />

           <Box className={classes.container} >
            <Box  className={classes.content}>
             
                {/* Header Title */}
                <Typography variant="h3" className={classes.title} >
                   بيع سيارتك المستعملة مع دوّر لي  
                </Typography>

                {/* Header Content */}
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                       <List>
                            <ListItem className={classes.listItem}>
                                <ListItemAvatar>
                                    <Avatar className={classes.listAvatar}>
                                        <TaskIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText className={classes.listText}  primary=" أدخل معلومات سيارتك "/>
                            </ListItem>
                            <ListItem className={classes.listItem}>
                                <ListItemAvatar>
                                    <Avatar className={classes.listAvatar}>
                                        <PlusCircleIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText className={classes.listText} primary="قم بتحميل صور لسيارتك " />
                            </ListItem>
                        </List>
                    </Grid>
                    

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                       <List>
                            <ListItem className={classes.listItem}>
                                <ListItemAvatar>
                                    <Avatar className={classes.listAvatar}>
                                        <PhoneIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText className={classes.listText}  primary=" تقديم تفاصيل الاتصال الخاصة بك"/>
                            </ListItem>
                            <ListItem className={classes.listItem}>
                                <ListItemAvatar>
                                    <Avatar className={classes.listAvatar}>
                                        <LocationIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText className={classes.listText} primary="موقع السيارة" />
                            </ListItem>
                        </List>
                    </Grid>
                    
                </Grid>

             </Box>
            </Box>
      </Box>
    </Hidden>   
  );
};

SectionFromHeader.propTypes = {
  width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
};

export default withWidth()(SectionFromHeader);
